import {Component} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {LeadSourcesResource} from '../../model/model-resource';
import {ResourceAutoCompleteComponent} from './resource-auto-complete.component';
import {LeadSource} from '../../model/lead-source';

@Component({
  selector: 'app-lead-source-auto-complete',
  templateUrl: './resource-auto-complete.component.html',
  styleUrls: ['./resource-auto-complete.component.scss']
})
export class LeadSourceAutoCompleteComponent extends ResourceAutoCompleteComponent<LeadSource> {
  constructor(builder: UntypedFormBuilder, resource: LeadSourcesResource) {
    super(builder, resource);
  }
}
